import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { RolesClient } from '@unity/clients';
import { DropdownClickableControlComponent } from '@unity/forms/dropdown-clickable-control/dropdown-clickable-control.component';
import { SessionService } from '@unity/services/session.service';

@Component({
  selector: 'unity-dropdown-agency-user-role-control',
  imports: [DropdownClickableControlComponent],
  templateUrl: './dropdown-agency-user-role-control.html',
  styleUrl: './dropdown-agency-user-role-control.scss',
})
export class DropdownAgencyUserRoleControl {
  private readonly sessionService = inject(SessionService);
  private readonly rolesClient = inject(RolesClient);

  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $userId = input.required<number>({ alias: 'userId' });

  private validRolesResource = rxResource({
    defaultValue: [],
    params: () => {
      const agencyId = this.sessionService.$currentAgencyId();
      const userId = this.$userId();
      return agencyId && userId ? { agencyId, userId } : undefined;
    },
    stream: ({ params: { agencyId, userId } }) => this.rolesClient.getAllAvailableForAgencyUserAsDetailed(agencyId, userId),
  });

  protected $validRoles = this.validRolesResource.value;
}
